import { Box, CircularProgress } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import DropDown from 'component/customize_select/customize_dropdown';
import StandardPopup from 'component/StandardPopup';
import { StandardQuantityBox } from 'component/StandardQuantityBox';
import { ToastType } from 'constants/index';
import { StockStatus } from 'containers/cart/type';
import { ItemInfoResponse, StyleResponse } from 'containers/session_details/type';
import React, { useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import themes from 'styles/themes';
import { strEllipsis } from 'utils/cuttext';
import { getStyleUrl } from 'utils/share';
import { useVisualViewport } from 'utils/useVisaulViewport';
import utils from 'utils/utils';
import { useStyles } from './style';
import { ReactComponent as OpenNewTab } from 'assets/svg/open-new-tab.svg';
import { GA_ENGAGEMENT_TYPE, GA_POST_MESSAGE_EVENT, PRODUCT_TYPE, TRACK_EVENT, trackEvent } from 'utils/analytics';
import { useMutation } from '@apollo/client';
import { CREATE_TRACK_SHOP_THE_ITEM } from 'graph_ql/track_shop_the_item/mutations';
import { RootState, useAppSelector } from '../../redux/store';
import { Currency } from '../../containers/user_reactions/types';
import { useSelector } from 'react-redux';
import { ReactComponent as DeleteIcon } from '../../assets/svg/icon_trash.svg';
import { PATH } from '../../routes/constant';
import config from 'config';
import { LanguageCode } from '__generated__/globalTypes';
import langUtils from '../../containers/language/utils';
import { useUrlQuery } from '../../hooks/useUrlQuery';
import { pick } from 'lodash';
import { sendTaffiEvent, WIDGET_TYPE } from '../../utils/trackUtils';

export interface IProps {
    item_name: String;
    price: any;
    quantity: any;
    sizeList?: any;
    colorList?: any;
    sizeValue: any;
    colorValue: any;
    image: string;
    currency: any;
    isDelete?: any;
    theme?: any;
    item?: any;
    id: any;
    index: number;
    handleChangeSize?: any;
    handleChangeColor?: any;
    handleChangeQuantity: (index: number, value: number) => void;
    isDropdown?: any;
    disableAction?: boolean;
    inStock?: StockStatus;
    availabilityCheck?: boolean;
    listItem?: ItemInfoResponse;
    supportsWidget?: boolean;
    styleData?: StyleResponse;
    onOpenItem?: Function;
    language?: string;
    hideButtonOnFirstItem?: boolean;
    taffiPrimaryProduct?: any | null;
}
function ItemCard({
    item_name,
    price,
    quantity,
    sizeList,
    colorList,
    image,
    sizeValue,
    colorValue,
    handleChangeQuantity,
    handleChangeSize,
    handleChangeColor,
    isDelete,
    theme,
    id,
    index,
    currency,
    isDropdown,
    disableAction,
    item,
    inStock,
    availabilityCheck,
    listItem,
    styleData,
    supportsWidget = false,
    onOpenItem = () => {},
    language = LanguageCode.english,
    hideButtonOnFirstItem = false,
    taffiPrimaryProduct = null,
}: IProps) {
    const location: any = useLocation();
    const classes = useStyles();
    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: '',
        button2: '',
        path: '',
        type: '',
        closeButton: true,
    });
    const isAppInWidgetMode = utils.isAppInWidgetMode() && supportsWidget;
    const [createTrackShopTheItem] = useMutation(CREATE_TRACK_SHOP_THE_ITEM);
    const storeId = useAppSelector((state: RootState) => state.widget.store?.id);
    const taffiStoreId = useSelector((state: RootState) => state.global.taffiStoreId);
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const searchQuery = useUrlQuery();
    const sourceUrl = searchQuery.get('sourceUrl');

    const handleIconClick = () => {
        if (inStock === StockStatus.True) {
            setModalShow({ ...modalShow, show: true, title: 'Item is available', type: ToastType.Success });
        } else if (inStock === StockStatus.Maybe) {
            setModalShow({
                ...modalShow,
                show: true,
                title: 'Item may not be available',
                content: 'We will try our best to secure this item but we cannot guarantee the availability',
                type: ToastType.Warning,
            });
        } else {
            setModalShow({ ...modalShow, show: true, title: 'Item is not available', type: ToastType.Error });
        }
    };
    const windowSize = useVisualViewport();

    const history = useHistory();

    const itemImage = Array.isArray(image) ? image[0] : image;

    const handleOpenItem = (item) => {
        onOpenItem &&
            onOpenItem({
                product_type: PRODUCT_TYPE.ITEM,
                contextType: PRODUCT_TYPE.STYLE,
                contextId: styleData?.id || item.contextId,
                contextTaffiId: styleData?.taffiId || item.contextTaffiId,
                product: item.data,
            });
        trackEvent(TRACK_EVENT.SHOP_THE_PRODUCT, {
            product_type: PRODUCT_TYPE.ITEM,
            contextType: PRODUCT_TYPE.STYLE,
            contextId: styleData?.id || item.contextId,
            contextTaffiId: styleData?.taffiId || item.contextTaffiId,
            recommendationSource: location.pathname,
            product: pick(item.data, ['id', 'taffiId', 'title', 'price', 'currency', 'url']),
            sourceUrl,
        });
        if (storeId || taffiStoreId) {
            createTrackShopTheItem({
                variables: {
                    input: {
                        itemId: item.id,
                        storeId: storeId || taffiStoreId,
                    },
                },
            });
        }
        const itemUrl = new URL(item?.data?.url);
        if (utils.isAppInWidgetMode()) {
            const targetOrigin = sourceUrl ? new URL(sourceUrl).origin : '*';
            sendTaffiEvent(
                GA_POST_MESSAGE_EVENT.TAFFI_WIDGET_ENGAGED,
                WIDGET_TYPE.PDP,
                {
                    product_id: taffiPrimaryProduct?.id,
                    product_url: sourceUrl,
                    product_taffi_id: taffiPrimaryProduct?.data?.taffiId,
                    style_taffi_id: styleData?.taffiId || item.contextTaffiId,
                    clicked_item_id: item.id,
                    clicked_item_taffi_id: item.data?.taffiId,
                    clicked_item_url: item.data?.url,
                    engagement_type: GA_ENGAGEMENT_TYPE.SHOP_THE_PRODUCT,
                },
                targetOrigin,
            );
            if (location?.pathname?.includes(PATH.STYLE_ASSISTANT)) {
                itemUrl?.searchParams?.append(config.widgetConstants.WIDGET_INITIAL_CLOSED, 'true');
                if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_PATH)) {
                    itemUrl?.searchParams?.set(config.widgetConstants.TAFFI_PATH, `${PATH.STYLE_ASSISTANT}`);
                } else {
                    itemUrl?.searchParams?.append(config.widgetConstants.TAFFI_PATH, `${PATH.STYLE_ASSISTANT}`);
                }
            } else if (!userDetail) {
                itemUrl?.searchParams?.append(config.widgetConstants.WIDGET_INITIAL_CLOSED, 'true');
                let taffiPath = `${PATH.DISCOVER_YOUR_STYLE}?taffiId=${styleData?.taffiId || item.contextTaffiId}`;
                if (location.pathname === PATH.STYLE_IT_RIGHT) {
                    const sourceProductUrl = location?.state?.sourceProductURL || searchQuery.get('sourceProductUrl');
                    taffiPath = `${PATH.STYLE_IT_RIGHT}?taffiId=${
                        styleData?.taffiId || item.contextTaffiId
                    }&sourceProductUrl=${sourceProductUrl}`;
                }
                if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_PATH)) {
                    itemUrl?.searchParams.set(config.widgetConstants.TAFFI_PATH, taffiPath);
                } else {
                    itemUrl?.searchParams.append(config.widgetConstants.TAFFI_PATH, taffiPath);
                }
            } else {
                if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_CONTEXT)) {
                    itemUrl.searchParams.set(
                        config.widgetConstants.TAFFI_CONTEXT,
                        styleData?.taffiId || item.contextTaffiId,
                    );
                } else {
                    itemUrl.searchParams.append(
                        config.widgetConstants.TAFFI_CONTEXT,
                        styleData?.taffiId || item.contextTaffiId,
                    );
                }
            }
        }
        window.open(itemUrl.href);
    };

    return (
        <div className={classes.bagItem} id="taffi-style-widget-shop-item-container">
            {item ? (
                <Link to={getStyleUrl(item)}>
                    <img src={itemImage} className={classes.itemImg} alt="" width={84} height={100} />
                </Link>
            ) : (
                <img src={itemImage} className={classes.itemImg} alt="" width={84} height={100} />
            )}

            <div className={classes.itemDetail} id="taffi-style-widget-item-content-container">
                <Box flex={1} id="taffi-style-widget-item-title-container">
                    <div className={classes.itemName}>
                        <span
                            style={{
                                color: `${
                                    theme === 'dark' ? themes.palette.primary.main : themes.palette.primary.main
                                }`,
                            }}
                        >
                            {windowSize.viewport.width === 375 ? strEllipsis(item_name, 25) : item_name}
                        </span>
                        {availabilityCheck ? (
                            item.checkingStock === true ? (
                                <span>
                                    <CircularProgress style={{ color: themes.palette.primary.main }} size="1rem" />{' '}
                                </span>
                            ) : inStock === StockStatus.True ? (
                                <span
                                    className={classes.itemStock}
                                    style={{
                                        color: themes.palette.info['500'],
                                    }}
                                    onClick={handleIconClick}
                                >
                                    {' '}
                                    <CheckCircleOutlineIcon fontSize="small" />{' '}
                                </span>
                            ) : inStock === StockStatus.Maybe ? (
                                <span
                                    className={classes.itemStock}
                                    style={{ color: 'orange' }}
                                    onClick={handleIconClick}
                                >
                                    {' '}
                                    <HelpOutlineOutlinedIcon fontSize="small" />{' '}
                                </span>
                            ) : inStock === StockStatus.False ? (
                                <span className={classes.itemStock} style={{ color: 'red' }} onClick={handleIconClick}>
                                    {' '}
                                    <ErrorOutlineIcon fontSize="small" />{' '}
                                </span>
                            ) : (
                                ''
                            )
                        ) : (
                            ''
                        )}
                    </div>
                    {!isAppInWidgetMode && !config.removeCheckOut && (
                        <div className={classes.itemDes}>
                            <span
                                className={classes.itemDropdown}
                                style={{
                                    color: `${
                                        theme === 'dark' ? themes.palette.primary.main : themes.palette.primary.main
                                    }`,
                                }}
                            >
                                <span>Size:</span>
                                {isDropdown ? (
                                    <DropDown
                                        value={sizeValue}
                                        handleChange={(e) => handleChangeSize(e, id)}
                                        items={sizeList}
                                    />
                                ) : (
                                    <span>{strEllipsis(sizeValue, 20)}</span>
                                )}
                            </span>
                            <span
                                className={classes.itemDropdown}
                                style={{
                                    color: `${
                                        theme === 'dark' ? themes.palette.primary.main : themes.palette.primary.main
                                    }`,
                                }}
                            >
                                <span>Color:</span>
                                {isDropdown ? (
                                    <DropDown
                                        value={colorValue}
                                        handleChange={(e) => handleChangeColor(e, id)}
                                        items={colorList}
                                    />
                                ) : (
                                    <span>{strEllipsis(colorValue, 20)}</span>
                                )}
                            </span>
                        </div>
                    )}
                </Box>
                <Box display={'flex'} alignItems={'center'} id="taffi-style-widget-item-price-container">
                    <span
                        className={classes.itemPrice}
                        style={{
                            color: `${theme === 'dark' ? themes.palette.primary.main : themes.palette.primary.main}`,
                        }}
                    >
                        {utils.getPrice(price, currency)}
                    </span>
                    {isAppInWidgetMode || currency !== Currency.Sar || config.removeCheckOut ? (
                        <>
                            {location.pathname === PATH.CART && !config.removeCheckOut && (
                                <DeleteIcon
                                    style={{
                                        cursor: 'pointer',
                                        opacity: disableAction ? 0.6 : 1,
                                        textAlign: 'center',
                                        color: themes.palette.primary.main,
                                    }}
                                    onClick={() => {
                                        if (disableAction) {
                                            return;
                                        }
                                        handleChangeQuantity(index, 0);
                                    }}
                                />
                            )}
                            {!hideButtonOnFirstItem && (
                                <button
                                    className={classes.widgetShopButton}
                                    onClick={() => handleOpenItem(listItem || item)}
                                    style={{ ...langUtils.getLanguageStyle(language) }}
                                    id="taffi-style-widget-shop-now-button"
                                >
                                    {utils.getStoreTranslatedString('shop_the_item')}
                                    <span
                                        style={{
                                            margin: langUtils.getMarginForDir(language, '5px'),
                                            marginBottom: 2,
                                        }}
                                    >
                                        <OpenNewTab />
                                    </span>
                                </button>
                            )}
                        </>
                    ) : (
                        <StandardQuantityBox
                            id={id}
                            index={index}
                            quantity={quantity}
                            handleChangeQuantity={handleChangeQuantity}
                            isDelete={isDelete ? isDelete : false}
                            theme={'light'}
                            disable={disableAction}
                        />
                    )}
                </Box>
                <StandardPopup
                    show={modalShow.show}
                    onHide={() => setModalShow({ ...modalShow, show: false })}
                    title={modalShow.title}
                    content={modalShow.content}
                    button1={modalShow.button1}
                    button2={modalShow.button2}
                    // path={modalShow.path}
                    onSecondButtonClick={() => {
                        if (modalShow.path) {
                            history.push(modalShow.path);
                        }
                    }}
                    type={modalShow.type as any}
                    closeButton={modalShow.closeButton}
                />
            </div>
        </div>
    );
}

export default ItemCard;
